import { Link } from "react-router-dom";
import { WHATSAPP_LINK } from "@/lib/config";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="font-display text-2xl font-extrabold mb-1">Ristrutturare Casa</div>
            <div className="text-brand-terracotta text-sm font-semibold tracking-[0.25em] uppercase mb-5">Napoli</div>
            <p className="text-white/50 max-w-sm leading-relaxed mb-5">
              Impresa di ristrutturazioni chiavi in mano a Napoli e provincia.
              Garanzie scritte, tempi certi e costi definitivi.
            </p>
            <div className="text-white/40 text-sm leading-relaxed">
              <div className="font-semibold text-white/70">Multiservice la Fenice S.R.L.s</div>
              <div>Via A. Carrelli, 50 - 80126 Napoli (NA)</div>
              <div>P. IVA e C.F. 11151291215 · REA NA-1158476</div>
              <div>PEC: multiservicelafenice@pec.it</div>
            </div>
          </div>
          <div>
            <div className="font-display font-bold mb-4">Link utili</div>
            <ul className="space-y-2 text-white/50 text-sm">
              <li><a href="/" className="hover:text-white transition-colors">Home</a></li>
              <li><Link to="/chi-siamo" className="hover:text-white transition-colors">Chi siamo</Link></li>
              <li><Link to="/perche-noi" className="hover:text-white transition-colors">Perché noi</Link></li>
              <li><a href="/#preventivo" className="hover:text-white transition-colors">Preventivo online</a></li>
              <li><Link to="/contatti" className="hover:text-white transition-colors">Contatti</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-display font-bold mb-4">Contatti & Legal</div>
            <ul className="space-y-2 text-white/50 text-sm">
              <li><a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">WhatsApp: +39 379 354 5087</a></li>
              <li><a href="tel:+393793545087" className="hover:text-white transition-colors">Tel: +39 379 354 5087</a></li>
              <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy" data-testid="footer-cookie-link" className="hover:text-white transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-white/40 text-sm">
          <span>© {new Date().getFullYear()} Multiservice la Fenice S.R.L.s — Ristrutturare Casa Napoli. Tutti i diritti riservati.</span>
          <span>P. IVA 11151291215</span>
        </div>
      </div>
    </footer>
  );
}
